/* eslint-disable react/no-unknown-property */
import React from 'react';
import PropTypes from 'prop-types';
import './Button.css';

const Button = ({ className, children, dataId, disabled, ...rest }) => (
  <button {...rest} dataid={dataId} className={`button ${className}`} disabled={disabled}>
    {children}
  </button>
);

Button.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  type: PropTypes.string,
  dataId: PropTypes.number,
  disabled: PropTypes.bool,
};

Button.defaultProps = {
  children: '',
  className: '',
  type: 'button',
  disabled: false,
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/Button.jsx